type Options = {
  map: google.maps.Map;
  position: google.maps.LatLng;
}

class CustomMarkerClass {

  static create() {

    class CustomMarker extends google.maps.OverlayView {

      div: HTMLDivElement;
      map: google.maps.Map;
      position: google.maps.LatLng;

      constructor(div: HTMLDivElement, options: Options) {
        super();
        this.div = div;
        this.map = options.map;
        this.position = options.position;
        this.init();
      }

      private init() {
        this.setMap(this.map);
      }

      onAdd() {
        this.getPanes().floatPane.appendChild(this.div);
      }

      onRemove() {
        if (this.div.parentElement) this.div.parentElement.removeChild(this.div);
      }

      draw() {
        const position = this.getProjection().fromLatLngToDivPixel(this.position);
        this.div.style.top = `${position.y}px`;
        this.div.style.left = `${position.x}px`;
      }

    }

    return CustomMarker;
  }

}

export default CustomMarkerClass;